import React from "react";
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import { Tinode } from "../tinode/tinode";

class PollMessage extends React.Component {
  constructor(props) {
    super(props);

    this.renderPollOptions = this.renderPollOptions.bind(this);
    this.handleShowPollDialog = this.handleShowPollDialog.bind(this);
    this.sortVote = this.sortVote.bind(this);
  }

  sortVote(a, b) {
    return (b?.voters?.length ? b?.voters?.length : 0 ) - (a?.voters?.length ? a?.voters?.length : 0 );
  }

  renderPollOptions(options) {
    if (options && options.length > 0) {
      const totalVote = options.reduce((n, { voters }) => n + (voters?.length ? voters.length : 0), 0);

      return options.sort(this.sortVote).map((item, index) => {
        const vote = item?.voters?.length ? item.voters.length : 0;
        return (
          <div className="poll" key={index}>
            <div className="quantity-and-title">
              <div className="title">{item.title}</div>
              <div className="quanity">
                <span>{vote}</span> <FormattedMessage
                  id="poll_vote"
                  defaultMessage={"Voted"}
                />
              </div>
            </div>
            <div className="percent-vote">
              <div className="percent" style={{ width: `${totalVote === 0 ? 0 : (vote / totalVote) * 100}%` }}></div>
            </div>
          </div>
        )
      })
    }
  }

  handleShowPollDialog() {
    const { id } = this.props;
    this.props.onShowDialog(Tinode.DIALOG_TYPE.SHOW_POLL, { pollMessageId: id })
  }

  render() {
    const pollMessage = this.props.pollMsg;
    const options = pollMessage?.options;
    return (
      <div className="content-poll">
        <div className="title">{pollMessage?.title}</div>
        <div className="poll-list">
          {this.renderPollOptions(options)}
        </div>
        <button className="btn-join-vote" onClick={this.handleShowPollDialog}>
          <FormattedMessage
            id="poll_btn_vote"
            defaultMessage={"Participate in voting"}
          />
        </button>
      </div>
    )
  }
}

export default injectIntl(PollMessage);